import { getApiUrl } from '@/api/apiClient.js';

const BASE = '/api/suppliers';

export default {
  getAll: () => getApiUrl(BASE),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  getUsersBySupplierId: (id) => getApiUrl(`${BASE}/${id}/users`),
  getTransferSenders: (id) => getApiUrl(`${BASE}/${id}/transfer_senders`),
  getRateCodes: (id) => getApiUrl(`${BASE}/${id}/rate_codes`),
  getRoomTypes: (id) => getApiUrl(`${BASE}/${id}/room_types`),
  getRoles: () => getApiUrl(`${BASE}/roles`),
  createSupplierUser: (id) => getApiUrl(`${BASE}/${id}/users`),
};
